/* eslint-disable @next/next/no-img-element */
import { EXCLAMATION_CIRCLE_RED } from '../../../config/constants/images';
import {
  NOT_PROCESS,
  OOPS_PAYMENT,
  TRY_AGAIN_PLEASE,
} from '../../../config/text/text';

const PaymentMessage = () => {
  return (
    <>
      <div className="payment-message">
        <img
          alt="Exclamation Circle Red"
          className="exclamation-circle-red"
          src={EXCLAMATION_CIRCLE_RED}
        />

        <p>{OOPS_PAYMENT}</p>
        <p className="middle-message"> {NOT_PROCESS}</p>
        <p>{TRY_AGAIN_PLEASE}</p>
      </div>
      <style jsx>{`
        .exclamation-circle-red {
          margin-bottom: 10px;
          width: 60px;
        }
        .middle-message {
          background: #d00303;
          color: white;
        }
        .payment-message {
          display: block;
          font-size: 1.5rem;
          font-weight: bold;
          text-align: center;
        }
      `}</style>
    </>
  );
};

PaymentMessage.propTypes = {};

export default PaymentMessage;
